"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.precompile14 = exports.BLS_MODULUS = void 0;
const tx_1 = require("@ethereumjs/tx");
const util_1 = require("@ethereumjs/util");
const evm_1 = require("../evm");
const exceptions_1 = require("../exceptions");
exports.BLS_MODULUS = BigInt('52435875175126190479447740508185965837690552500527637822603658699938581184513');
async function precompile14(opts) {
    const gasUsed = opts._common.param('gasPrices', 'kzgPointEvaluationGasPrecompilePrice');
    if (opts._debug) {
        opts._debug(`Run KZG_POINT_EVALUATION (0x14) precompile data=${(0, util_1.short)(opts.data)} length=${opts.data.length} gasLimit=${opts.gasLimit} gasUsed=${gasUsed}`);
    }
    const version = Number(opts._common.paramByEIP('sharding', 'blobCommitmentVersionKzg', 4844));
    const fieldElementsPerBlob = opts._common.paramByEIP('sharding', 'fieldElementsPerBlob', 4844);
    const versionedHash = opts.data.slice(0, 32);
    const z = opts.data.slice(32, 64);
    const y = opts.data.slice(64, 96);
    const commitment = opts.data.slice(96, 144);
    const kzgProof = opts.data.slice(144, 192);
    if ((0, util_1.bufferToBigInt)(z) >= exports.BLS_MODULUS || (0, util_1.bufferToBigInt)(y) >= exports.BLS_MODULUS) {
        if (opts._debug) {
            opts._debug(`KZG_POINT_EVALUATION (0x14) failed: POINT_GREATER_THAN_BLS_MODULUS`);
        }
        return (0, evm_1.EvmErrorResult)(new exceptions_1.EvmError(exceptions_1.ERROR.POINT_GREATER_THAN_BLS_MODULUS), opts.gasLimit);
    }
    if ((0, util_1.bufferToHex)(Buffer.from((0, tx_1.computeVersionedHash)(commitment, version))) !==
        (0, util_1.bufferToHex)(versionedHash)) {
        if (opts._debug) {
            opts._debug(`KZG_POINT_EVALUATION (0x14) failed: INVALID_COMMITMENT`);
        }
        return (0, evm_1.EvmErrorResult)(new exceptions_1.EvmError(exceptions_1.ERROR.INVALID_COMMITMENT), opts.gasLimit);
    }
    if (opts._debug) {
        opts._debug(`KZG_POINT_EVALUATION (0x14): proof verification with commitment=${commitment.toString('hex')} z=${z.toString('hex')} y=${y.toString('hex')} kzgProof=${kzgProof.toString('hex')}`);
    }
    tx_1.kzg.verifyKzgProof(commitment, z, y, kzgProof);
    // Return value - FIELD_ELEMENTS_PER_BLOB and BLS_MODULUS as padded 32 byte big endian values
    const fieldElements = (0, util_1.setLengthLeft)((0, util_1.bigIntToBuffer)(fieldElementsPerBlob), 32);
    const modulus = (0, util_1.setLengthLeft)((0, util_1.bigIntToBuffer)(exports.BLS_MODULUS), 32);
    if (opts._debug) {
        opts._debug(`KZG_POINT_EVALUATION (0x14) return fieldElements=${fieldElements.toString('hex')} modulus=${modulus.toString('hex')}`);
    }
    return {
        executionGasUsed: gasUsed,
        returnValue: Buffer.concat([fieldElements, modulus]),
    };
}
exports.precompile14 = precompile14;
//# sourceMappingURL=14-kzg-point-evaluation.js.map